export default "__VITE_ASSET__d4515568__"